export default __webpack_public_path__ + "static/media/Map5-1.ee2eef17.png";